import React, { useContext } from "react";
import QRcode from "qrcode.react";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import { ContextGlobal } from "../../context";
import { Paper, Typography } from "@material-ui/core";

const styles = () => ({
  paper: {
    width: "max-content",
    margin: "auto",
    overflow: "hidden",
  },
});

const QRCode = (props) => {
  const { classes } = props;
  const { data } = useContext(ContextGlobal);
  return (
    <Paper className={classes.paper}>
      <QRcode value={data.data.QRcode} size={320} includeMargin={true} />
      <Typography variant="caption" display="block" gutterBottom align="center">
        Your QR code
      </Typography>
    </Paper>
  );
};

QRCode.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(QRCode);
